import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableRow, IconButton, useMediaQuery } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import { useTheme } from "@mui/material/styles";

const ContactPanel = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Compact cell style for mobile
  const compactCell = { borderBottom: "none", padding: "4px 8px", fontSize: "1rem" };

  return (
    <Paper
      elevation={3}
      sx={{
        margin: { xs: "20px 10% 40px 10%", sm: "20px 10%" }, // extra bottom margin for mobile
        padding: "16px",
        textAlign: "center"
      }}
    >
      <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: "20px" }}>
        Contact Information
      </Typography>
      <TableContainer>
        <Table>
          <TableBody>
            {isMobile ? (
              <>
                <TableRow>
                  <TableCell align="center" sx={{ ...compactCell, fontWeight: "bold" }}>
                    Phone
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={compactCell}>
                    +1 612-401-4794
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={{ ...compactCell, fontWeight: "bold" }}>
                    Email
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={compactCell}>
                    matthew.w.nielsen@gmail.com
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={{ ...compactCell, fontWeight: "bold" }}>
                    Facebook
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={compactCell}>
                    <IconButton
                      component="a"
                      href="https://www.facebook.com/profile.php?id=61581158817799"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                      color="primary"
                      sx={{ fontSize: 32 }}
                    >
                      <FacebookIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </>
            ) : (
              <>
                <TableRow>
                  <TableCell align="center" sx={{ fontWeight: "bold", borderBottom: "none" }}>
                    Phone
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", borderBottom: "none" }}>
                    Email
                  </TableCell>
                  <TableCell align="center" sx={{ fontWeight: "bold", borderBottom: "none" }}>
                    Facebook
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center" sx={{ borderBottom: "none" }}>
                    +1 612-401-4794
                  </TableCell>
                  <TableCell align="center" sx={{ borderBottom: "none" }}>
                    matthew.w.nielsen@gmail.com
                  </TableCell>
                  <TableCell align="center" sx={{ borderBottom: "none" }}>
                    <IconButton
                      component="a"
                      href="https://www.facebook.com/profile.php?id=61581158817799"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Facebook"
                      color="primary"
                      sx={{ fontSize: 32 }}
                    >
                      <FacebookIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ContactPanel;
